
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33771',
  depVersions: {
  "documents-public-ui": "static-1.33771",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33776",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1831",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5302",
  "hs-test-utils": "static-1.7694",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11135",
  "I18n": "static-7.1545",
  "jasmine-immutable": "static-1.2729",
  "jasmine-runner": "static-1.6166",
  "lodash": "static-1.3",
  "quartz": "static-1.6595",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16344",
  "reporting-data": "static-1.66155",
  "reporting-testing-lib": "static-1.8088",
  "reporting-visualizations": "static-1.58231",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4456",
  "webpack-env": "static-1.54",
  "atom": "static-1.4783",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2177",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.704",
  "customer-data-filters-ui": "static-1.38571",
  "customer-data-objects": "static-1.7324",
  "customer-data-property-utils": "static-1.7781",
  "data-fetching-client": "static-1.9387",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4246",
  "flux-actions": "static-1.298",
  "FormsCommonComponents": "static-1.85045",
  "FormUrlGenerator": "static-2.4442",
  "foundations-components": "static-1.7337",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11443",
  "icons": "static-2.614",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6855",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3571",
  "property-translator": "static-1.5125",
  "quartz-config": "static-1.373",
  "quartz-core": "static-1.5814",
  "quick-fetch": "static-1.3648",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5095",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7873",
  "reference-resolvers-lite": "static-1.7801",
  "report-customization-components": "static-1.12257",
  "reporting-enablement": "static-1.21795",
  "reporting-reports": "static-1.65833",
  "reporting-snowflake": "static-1.54773",
  "reporting-ui-components": "static-2.63427",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4318",
  "sales-content-partitioning": "static-1.8645",
  "SalesContentIndexUI": "static-3.8759",
  "sanitize": "static-1.4186",
  "sanitize-text": "static-1.7851",
  "self-service-api": "static-1.9937",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1461",
  "signup-constants": "static-1.18227",
  "signup-ui-lego-core": "static-1.20237",
  "signup-ui-url-generator": "static-2.7743",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4484",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10707",
  "ui-addon-i18n": "static-1.10840",
  "ui-addon-react-router-dom": "static-1.9258",
  "ui-addon-upgrades": "static-9.17434",
  "ui-asset-management-lib": "static-1.10575",
  "ui-images": "static-2.1065",
  "UIComponents": "static-3.8082",
  "usage-tracker": "static-1.7047",
  "usage-tracker-container": "static-1.7037",
  "usage-tracker-core": "static-1.6897",
  "usage-tracker-public": "static-1.6858",
  "viral-links-lib": "static-1.6731",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3148",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2872",
  "quartz-webpack": "static-1.2819",
  "ai-components-ui-library": "static-1.8122",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4543",
  "foundations-theming": "static-1.4115",
  "quartz-auth": "static-1.270",
  "usage-tracker-session-replay": "static-1.4733",
  "foundations-theming-base": "static-1.3100",
  "HeadJS": "static-2.693",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2805",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4043",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7635",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3379",
  "persist-promise": "static-1.3398",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9138",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9241",
  "hubspotter-http": "static-1.4397",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6962",
  "crm-message-bus": "static-1.42136",
  "customer-data-filters-ui-msw-helpers": "static-1.21005",
  "customer-data-objects-ui-components": "static-1.12713",
  "customer-data-reference-ui-components": "static-1.12850",
  "customer-data-ui-utilities": "static-1.9537",
  "framework-builder-read-service-client": "static-1.3766",
  "framework-data-schema-quick-fetch": "static-1.6486",
  "framework-data-schema-resolvers": "static-1.6581",
  "inbound-db-properties-service-client": "static-1.3598",
  "multi-account-reference-resolvers": "static-1.679",
  "onboarding-tours": "static-1.16149",
  "reporting-datasets-permissions-lib": "static-1.12758",
  "ui-addon-teams": "static-1.21104",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67362",
  "customer-data-properties": "static-1.50522",
  "forms-ai-lib": "static-1.3860",
  "forms-utils-lib": "static-1.12002",
  "foundations-components-test-utils": "static-1.4820",
  "react-dnd-compat": "static-1.4335",
  "react-tinymce": "static-1.54390",
  "tinymce-config": "static-2.53516",
  "ui-gdpr-components": "static-1.10056",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3606",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.996",
  "ui-fonts": "static-1.397",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.774",
  "mobile-manifest-mixins": "static-1.466",
  "quartz-head": "static-1.260",
  "quartz-i18n": "static-1.270",
  "quartz-test": "static-1.270",
  "batch-promise": "static-1.1241",
  "external-options-client-types": "static-1.3902",
  "react-colorpicker": "static-2.9924",
  "copilot-toolkit": "static-1.10315",
  "data-quality-ui-library": "static-1.12124",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40459",
  "reporting-insights-lib": "static-1.915",
  "reporting-plugins": "static-1.9873",
  "ui-addon-draggable-compat": "static-2.3965",
  "ui-addon-opt": "static-4.8100",
  "ui-shepherd-react": "static-3.9855",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24484",
  "hubspot-apollo-client": "static-1.4591",
  "sales-templates-service-types-lib": "static-1.3912",
  "ui-business-units-lib": "static-1.8733",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5345",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3823",
  "upgrade-management-service-types": "static-1.4219",
  "timezone-utils": "static-2.4955",
  "bender-build-tools": "static-1.2823",
  "chatspot-core": "static-1.20011",
  "chirp-fetch": "static-1.1593",
  "bend-plugin-foundations-theming": "static-1.2598",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9239",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3542",
  "crm-pipelines-api-client-types": "static-1.3884",
  "multi-currency-client-types": "static-1.3440",
  "getting-started-shared-tasks": "static-1.17633",
  "growth-data-modal": "static-1.5044",
  "growth-onboarding-confetti": "static-1.2762",
  "growth-onboarding-next-action-utils": "static-1.1206",
  "navigation-components": "static-1.17018",
  "onboarding-tours-client": "static-1.4363",
  "onboarding-tours-utils": "static-1.215",
  "ui-shepherd-tracker": "static-1.7236",
  "ui-universal-auth": "static-1.8577",
  "user-context": "static-1.4806",
  "cms-field-types": "static-1.4519",
  "content-icons-ui": "static-1.2123",
  "integrations-lib": "static-1.15135",
  "calling-global-api": "static-1.63377",
  "calling-internal-common": "static-1.31000",
  "calling-lifecycle-internal": "static-1.64759",
  "calling-lifecycle-messages": "static-1.57053",
  "commerce-products-lib": "static-1.8586",
  "crm-links": "static-1.5963",
  "file-manager-components": "static-1.22643",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.370",
  "inbounddb-objects-service-types": "static-1.3969",
  "meetings-icalendar-utils-lib": "static-1.345",
  "object-builder-ui-client": "static-1.47696",
  "pipeline-validation-client-types": "static-1.3706",
  "property-value-citations": "static-1.1136",
  "pulse": "static-1.207",
  "smart-property-lib": "static-1.5581",
  "tiered-pricing": "static-1.684",
  "ui-addon-iframeable": "static-1.8730",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19312",
  "tinymce-themes": "static-1.55486",
  "data-token-picker": "static-1.15908",
  "hub-http-contrib": "static-1.2757",
  "interframe": "static-3.4504",
  "tinymce-data": "static-1.39601",
  "tinymce-plugins": "static-1.56630",
  "ui-addon-sales-email": "static-1.4925",
  "magpie-lib": "static-1.5287",
  "magpie-types": "static-1.4747",
  "simple-logging-lib": "static-1.2762",
  "content-assistance-lib": "static-1.7320",
  "dashboard-lib": "static-1.80277",
  "ExportDialog": "static-6.10099",
  "hubspot-prosemirror": "static-1.17374",
  "hubspot-prosemirror-plugins": "static-1.17366",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8401",
  "campaign-roi-lib": "static-1.8022",
  "feedback-loader": "static-1.28698",
  "commerce-analytics-service-client": "static-1.3400",
  "onboarding-scopes": "static-1.6154",
  "apollo-link-hub-http": "static-2.4360",
  "hubspot-apollo-cache": "static-1.50",
  "growth-monetization-service-types": "static-1.4235",
  "nav-client-types": "static-1.2044",
  "purchase-motions-api": "static-1.5348",
  "trials-service-types": "static-1.3636",
  "chatspot-client-types": "static-1.10365",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.437",
  "getting-started-shared-tasks-store": "static-1.16751",
  "cohere-reconnect-lib": "static-1.81",
  "gemini-reconnect-lib": "static-1.40",
  "integrations-error-boundary-lib": "static-1.12550",
  "integrations-tracking-lib": "static-1.5295",
  "native-integrations-shared-strings": "static-1.7500",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10084",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31006",
  "shared-worker-versioning": "static-1.10728",
  "calling-usage-tracker": "static-1.6250",
  "calling-orchestration-shared-library": "static-1.34539",
  "customer-data-tracking": "static-1.6573",
  "products-iframe-lib": "static-1.7104",
  "products-ui-components-shared-msw-handlers": "static-1.9623",
  "location-customization-utils-lib": "static-1.8281",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3867",
  "video-components-external": "static-1.10296",
  "video-data-lib": "static-1.33954",
  "directed-graph": "static-1.649",
  "event-emitter": "static-1.636",
  "breeze-intelligence-kit": "static-1.5189",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9324",
  "fsm": "static-1.3442",
  "policy-lib": "static-1.6513",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9387",
  "navigation-messaging": "static-1.6345",
  "FileManagerLib": "static-1.38283",
  "NamespacedHubStyle": "static-2.8818",
  "FileManagerCore": "static-1.38142",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11881",
  "layout-dnd-utils": "static-1.10856",
  "react-codemirror": "static-1.10316",
  "ui-addon-emoji-picker": "static-1.9601",
  "ui-brand-identity-lib": "static-1.13463",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27706",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8277",
  "payment-link-components": "static-1.22686",
  "EmailSignatureEditor": "static-1.23770",
  "eligibility-engine-service-types": "static-1.2917",
  "universal-page-editor-lib": "static-1.2708",
  "calling-orchestration-schema": "static-1.34764",
  "sales-views-client-types": "static-1.4004",
  "crm-record-cards-service-types": "static-1.3371",
  "content-media-composition-data-lib": "static-1.11098",
  "content-media-compositions": "static-2.15105",
  "media-bridge-lib": "static-1.18429",
  "trellis-story-utils": "static-1.4234",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5484",
  "FileManagerImages": "static-1.35794",
  "video-components": "static-1.12299",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4246",
  "video-embed": "static-1.34788",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67437",
  "layout-data-lib": "static-1.9181",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6297",
  "commerce-tours-lib": "static-1.5577",
  "growth-onboarding-reliability": "static-1.4799",
  "sales-checkout-service-client": "static-1.3412",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21150",
  "sales-email-signature-service-client": "static-1.3553",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21128",
  "outpost": "static-1.3923",
  "advanced-menus-core": "static-1.14670",
  "advanced-menus-lib": "static-1.11661",
  "ui-memberships-settings-lib": "static-1.33192",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14669",
  "simple-menus-lib": "static-1.16186"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33771",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33776",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1831",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5302",
  "hs-test-utils": "/hs-test-utils/static-1.7694",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11135",
  "I18n": "/I18n/static-7.1545",
  "jasmine-immutable": "/jasmine-immutable/static-1.2729",
  "jasmine-runner": "/jasmine-runner/static-1.6166",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6595",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16344",
  "reporting-data": "/reporting-data/static-1.66155",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8088",
  "reporting-visualizations": "/reporting-visualizations/static-1.58231",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4456",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4783",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2177",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.704",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38571",
  "customer-data-objects": "/customer-data-objects/static-1.7324",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7781",
  "data-fetching-client": "/data-fetching-client/static-1.9387",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4246",
  "flux-actions": "/flux-actions/static-1.298",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85045",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4442",
  "foundations-components": "/foundations-components/static-1.7337",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11443",
  "icons": "/icons/static-2.614",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6855",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3571",
  "property-translator": "/property-translator/static-1.5125",
  "quartz-config": "/quartz-config/static-1.373",
  "quartz-core": "/quartz-core/static-1.5814",
  "quick-fetch": "/quick-fetch/static-1.3648",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5095",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7873",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7801",
  "report-customization-components": "/report-customization-components/static-1.12257",
  "reporting-enablement": "/reporting-enablement/static-1.21795",
  "reporting-reports": "/reporting-reports/static-1.65833",
  "reporting-snowflake": "/reporting-snowflake/static-1.54773",
  "reporting-ui-components": "/reporting-ui-components/static-2.63427",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4318",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8645",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8759",
  "sanitize": "/sanitize/static-1.4186",
  "sanitize-text": "/sanitize-text/static-1.7851",
  "self-service-api": "/self-service-api/static-1.9937",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1461",
  "signup-constants": "/signup-constants/static-1.18227",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20237",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7743",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4484",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10707",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10840",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9258",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17434",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10575",
  "ui-images": "/ui-images/static-2.1065",
  "UIComponents": "/UIComponents/static-3.8082",
  "usage-tracker": "/usage-tracker/static-1.7047",
  "usage-tracker-container": "/usage-tracker-container/static-1.7037",
  "usage-tracker-core": "/usage-tracker-core/static-1.6897",
  "usage-tracker-public": "/usage-tracker-public/static-1.6858",
  "viral-links-lib": "/viral-links-lib/static-1.6731",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3148",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2872",
  "quartz-webpack": "/quartz-webpack/static-1.2819",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8122",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4543",
  "foundations-theming": "/foundations-theming/static-1.4115",
  "quartz-auth": "/quartz-auth/static-1.270",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4733",
  "foundations-theming-base": "/foundations-theming-base/static-1.3100",
  "HeadJS": "/HeadJS/static-2.693",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2805",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4043",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7635",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3379",
  "persist-promise": "/persist-promise/static-1.3398",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9138",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9241",
  "hubspotter-http": "/hubspotter-http/static-1.4397",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6962",
  "crm-message-bus": "/crm-message-bus/static-1.42136",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21005",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12713",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12850",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9537",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3766",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6486",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6581",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3598",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.679",
  "onboarding-tours": "/onboarding-tours/static-1.16149",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12758",
  "ui-addon-teams": "/ui-addon-teams/static-1.21104",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67362",
  "customer-data-properties": "/customer-data-properties/static-1.50522",
  "forms-ai-lib": "/forms-ai-lib/static-1.3860",
  "forms-utils-lib": "/forms-utils-lib/static-1.12002",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4820",
  "react-dnd-compat": "/react-dnd-compat/static-1.4335",
  "react-tinymce": "/react-tinymce/static-1.54390",
  "tinymce-config": "/tinymce-config/static-2.53516",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10056",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3606",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.996",
  "ui-fonts": "/ui-fonts/static-1.397",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.774",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.466",
  "quartz-head": "/quartz-head/static-1.260",
  "quartz-i18n": "/quartz-i18n/static-1.270",
  "quartz-test": "/quartz-test/static-1.270",
  "batch-promise": "/batch-promise/static-1.1241",
  "external-options-client-types": "/external-options-client-types/static-1.3902",
  "react-colorpicker": "/react-colorpicker/static-2.9924",
  "copilot-toolkit": "/copilot-toolkit/static-1.10315",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12124",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40459",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.915",
  "reporting-plugins": "/reporting-plugins/static-1.9873",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3965",
  "ui-addon-opt": "/ui-addon-opt/static-4.8100",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9855",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24484",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4591",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3912",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8733",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5345",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3823",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4219",
  "timezone-utils": "/timezone-utils/static-2.4955",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "chatspot-core": "/chatspot-core/static-1.20011",
  "chirp-fetch": "/chirp-fetch/static-1.1593",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2598",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9239",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3542",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3884",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3440",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17633",
  "growth-data-modal": "/growth-data-modal/static-1.5044",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2762",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1206",
  "navigation-components": "/navigation-components/static-1.17018",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4363",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.215",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7236",
  "ui-universal-auth": "/ui-universal-auth/static-1.8577",
  "user-context": "/user-context/static-1.4806",
  "cms-field-types": "/cms-field-types/static-1.4519",
  "content-icons-ui": "/content-icons-ui/static-1.2123",
  "integrations-lib": "/integrations-lib/static-1.15135",
  "calling-global-api": "/calling-global-api/static-1.63377",
  "calling-internal-common": "/calling-internal-common/static-1.31000",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64759",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57053",
  "commerce-products-lib": "/commerce-products-lib/static-1.8586",
  "crm-links": "/crm-links/static-1.5963",
  "file-manager-components": "/file-manager-components/static-1.22643",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.370",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3969",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.345",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47696",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3706",
  "property-value-citations": "/property-value-citations/static-1.1136",
  "pulse": "/pulse/static-1.207",
  "smart-property-lib": "/smart-property-lib/static-1.5581",
  "tiered-pricing": "/tiered-pricing/static-1.684",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8730",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19312",
  "tinymce-themes": "/tinymce-themes/static-1.55486",
  "data-token-picker": "/data-token-picker/static-1.15908",
  "hub-http-contrib": "/hub-http-contrib/static-1.2757",
  "interframe": "/interframe/static-3.4504",
  "tinymce-data": "/tinymce-data/static-1.39601",
  "tinymce-plugins": "/tinymce-plugins/static-1.56630",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4925",
  "magpie-lib": "/magpie-lib/static-1.5287",
  "magpie-types": "/magpie-types/static-1.4747",
  "simple-logging-lib": "/simple-logging-lib/static-1.2762",
  "content-assistance-lib": "/content-assistance-lib/static-1.7320",
  "dashboard-lib": "/dashboard-lib/static-1.80277",
  "ExportDialog": "/ExportDialog/static-6.10099",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17374",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17366",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8401",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8022",
  "feedback-loader": "/feedback-loader/static-1.28698",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3400",
  "onboarding-scopes": "/onboarding-scopes/static-1.6154",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4360",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.50",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4235",
  "nav-client-types": "/nav-client-types/static-1.2044",
  "purchase-motions-api": "/purchase-motions-api/static-1.5348",
  "trials-service-types": "/trials-service-types/static-1.3636",
  "chatspot-client-types": "/chatspot-client-types/static-1.10365",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.437",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16751",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.81",
  "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.40",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12550",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5295",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7500",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10084",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31006",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10728",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6250",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34539",
  "customer-data-tracking": "/customer-data-tracking/static-1.6573",
  "products-iframe-lib": "/products-iframe-lib/static-1.7104",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9623",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8281",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3867",
  "video-components-external": "/video-components-external/static-1.10296",
  "video-data-lib": "/video-data-lib/static-1.33954",
  "directed-graph": "/directed-graph/static-1.649",
  "event-emitter": "/event-emitter/static-1.636",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5189",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9324",
  "fsm": "/fsm/static-1.3442",
  "policy-lib": "/policy-lib/static-1.6513",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9387",
  "navigation-messaging": "/navigation-messaging/static-1.6345",
  "FileManagerLib": "/FileManagerLib/static-1.38283",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8818",
  "FileManagerCore": "/FileManagerCore/static-1.38142",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11881",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10856",
  "react-codemirror": "/react-codemirror/static-1.10316",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9601",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13463",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27706",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8277",
  "payment-link-components": "/payment-link-components/static-1.22686",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23770",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2917",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2708",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34764",
  "sales-views-client-types": "/sales-views-client-types/static-1.4004",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3371",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11098",
  "content-media-compositions": "/content-media-compositions/static-2.15105",
  "media-bridge-lib": "/media-bridge-lib/static-1.18429",
  "trellis-story-utils": "/trellis-story-utils/static-1.4234",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5484",
  "FileManagerImages": "/FileManagerImages/static-1.35794",
  "video-components": "/video-components/static-1.12299",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4246",
  "video-embed": "/video-embed/static-1.34788",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67437",
  "layout-data-lib": "/layout-data-lib/static-1.9181",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6297",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5577",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4799",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3412",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21150",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3553",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "outpost": "/outpost/static-1.3923",
  "advanced-menus-core": "/advanced-menus-core/static-1.14670",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11661",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33192",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14669",
  "simple-menus-lib": "/simple-menus-lib/static-1.16186"
}
};
